import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { screenReaderOnly } from '../../../styles';
import Label from '../../typography/label';
import styled from '../../../styles/styled';
import { Box, Flex } from '../../layout';
import { AppIcon } from '../../icons';
export const Checkbox = props => {
    const { checked, onChange, label, borderColor, small, disabled } = props;
    const id = `checkbox_${label}`;
    return (_jsxs(CheckboxContainer, { "data-testid": props['data-testid'], alignItems: "center", justifyContent: "center", onClick: disabled ? undefined : onChange, checked: checked, disabled: disabled, children: [_jsx(Label, { htmlFor: id, screenReaderOnly: true, children: label }), _jsx("input", { id: id, style: screenReaderOnly, type: "checkbox", tabIndex: 0, checked: checked, onChange: disabled ? undefined : onChange, disabled: disabled }), _jsx(CheckedIndicator, { disabled: disabled, small: small, borderColor: borderColor, checked: !!checked, children: checked && _jsx(AppIcon, { name: "CheckmarkIcon", color: "white" }) })] }));
};
const CheckboxContainer = styled(Flex)({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
}, ({ theme, checked, disabled }) => ({
    cursor: disabled ? 'not-allowed' : 'pointer',
    ':hover': {
        backgroundColor: !disabled ? `${theme.colors.blue50}15` : undefined,
    },
    ':active': {
        backgroundColor: disabled
            ? undefined
            : checked
                ? `${theme.colors.blue50}25`
                : `${theme.colors.blue50}20`,
    },
}));
const CheckedIndicator = styled(Box)({
    transition: 'background-color 0.2s',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}, ({ checked, theme, small, borderColor, disabled }) => ({
    backgroundColor: checked && disabled
        ? theme.colors.grey20
        : checked
            ? theme.colors.blue50
            : borderColor
                ? borderColor
                : undefined,
    height: small ? '20px' : '24px',
    width: small ? '20px' : '24px',
    border: `2px solid ${disabled ? theme.colors.grey20 : checked ? theme.colors.blue50 : theme.colors.grey50}`,
    ':hover': {
        border: `2px solid ${disabled ? theme.colors.grey20 : checked ? theme.colors.blue60 : theme.colors.grey50}`,
        backgroundColor: checked && disabled
            ? theme.colors.grey20
            : checked
                ? theme.colors.blue60
                : undefined,
    },
    ':active': {
        backgroundColor: checked ? theme.colors.blue70 : undefined,
        border: `2px solid ${disabled ? theme.colors.grey20 : checked ? theme.colors.blue70 : theme.colors.grey50}`,
    },
}));
//# sourceMappingURL=checkbox.js.map